import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ThreadSummary } from '@core/tellent-assistant-types';
import { ButtonComponent, IconButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-thread-drawer',
  standalone: true,
  imports: [ButtonComponent, IconButtonComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'complementary' },
  template: `
    <header class="top">
      <rt-icon-button
        iconName="arrow-back"
        size="small"
        variant="plain"
        aria-label="Back"
        (click)="back.emit()"
      />
    </header>

    <rt-button
      class="new"
      variant="plain"
      size="medium"
      layout-full-width
      (click)="newThread.emit()"
    >
      <rt-icon name="edit-square" colorToken="colorIconPrimaryDefault" />
      <span class="new-label">New conversation</span>
    </rt-button>

    <p class="label">Conversation history</p>
    <ul>
      @for (thread of threads(); track thread.id) {
        <li>
          <rt-button
            variant="plain"
            size="medium"
            layout-full-width
            [class.active]="thread.id === activeId()"
            (click)="selectThread.emit(thread.id)"
          >
            <span class="thread-title">{{ thread.title }}</span>
            <rt-icon-button
              iconName="delete"
              size="small"
              variant="plain"
              class="delete"
              aria-label="Delete conversation"
              [disabled]="isDeleting()(thread.id)"
              data-testid="thread-delete"
              (click)="onDeleteClick(thread.id, $event)"
            />
          </rt-button>
        </li>
      }
    </ul>

    <footer class="bottom">
      <rt-button
        class="action"
        variant="plain"
        size="medium"
        layout-full-width
        (click)="helpCenter.emit()"
      >
        <rt-icon name="help-outline" class="action-icon" />
        <span class="action-label">Help center</span>
        <rt-icon name="open-in-new" class="external" />
      </rt-button>
      <rt-button
        class="action"
        variant="plain"
        size="medium"
        layout-full-width
        (click)="intelligenceSettings.emit()"
      >
        <rt-icon name="nav-settings-outline" class="action-icon" />
        <span class="action-label">Intelligence settings</span>
        <rt-icon name="open-in-new" class="external" />
      </rt-button>
    </footer>
  `,
  styleUrls: ['./tellent-assistant-thread-drawer.component.less'],
})
export class TellentAssistantThreadDrawerComponent {
  public readonly threads = input.required<readonly ThreadSummary[]>();
  public readonly activeId = input<string | null>(null);
  public readonly isDeleting = input<(threadId: string) => boolean>(() => false);
  public readonly back = output<void>();
  public readonly newThread = output<void>();
  public readonly selectThread = output<string>();
  public readonly deleteThread = output<string>();
  public readonly helpCenter = output<void>();
  public readonly intelligenceSettings = output<void>();

  public onDeleteClick(threadId: string, event: Event): void {
    event.stopPropagation();
    this.deleteThread.emit(threadId);
  }
}
